export interface VerifyContractorDto {
  isVerified: boolean;
  reason?: string | null;
}

export interface ContractorVerificationResultDto {
  contractorId: string;
  isVerified: boolean;
  verifiedAt?: string | null; // DateTime as ISO string
  verifiedBy?: string | null;
  verifiedByName?: string | null;
  message?: string | null;
}
